var map = {
	"./banner-new.png": 1062,
	"./card-bg-1.png": 1134,
	"./card-bg-2.png": 1135,
	"./card-bg-3-old.png": 1136,
	"./card-bg-3.png": 1137,
	"./card-bg-small.png": 1138,
	"./coupon-icon.png": 1139,
	"./genshin/button-bg.png": 1140,
	"./genshin/coupon.png": 1029,
	"./genshin/coupon_bg.png": 1141,
	"./genshin/coupon_bg_popup_1.png": 1142,
	"./genshin/coupon_bg_popup_2.png": 1143,
	"./genshin/gift_bg.png": 1144,
	"./genshin/gift_bg_popup_1.png": 1145,
	"./genshin/gift_bg_popup_2.png": 1146,
	"./genshin/kGold.png": 1147,
	"./genshin/popup-bg-1.png": 1148,
	"./genshin/popup-bg-2.png": 1149,
	"./genshin/popup-bg-invited.png": 1150,
	"./genshin/popup-bg_GT.png": 1151,
	"./genshin/popup-btn-guest-login.png": 1152,
	"./genshin/popup-btn-guest.png": 1153,
	"./genshin/popup-btn-owner.png": 1154,
	"./icon/award__coupon.png": 1009,
	"./icon/coupon-new.png": 1024,
	"./icon/coupon.png": 1008,
	"./icon/facebook.png": 1057,
	"./icon/gift.png": 1038,
	"./icon/google.png": 1058,
	"./icon/kgold-new.png": 1059,
	"./icon/kgold.png": 1060,
	"./icon/score-icon.png": 1015,
	"./icon/uc-new.png": 1025,
	"./mlbb-banner.png": 1093,
	"./mlbb.png": 1155,
	"./mobile-legends/award.png": 1156,
	"./mobile-legends/button-bg.png": 1157,
	"./mobile-legends/coupon-icon.png": 1158,
	"./mobile-legends/coupon_bg.png": 1069,
	"./mobile-legends/coupon_bg_popup_1.png": 1159,
	"./mobile-legends/coupon_bg_popup_2.png": 1160,
	"./mobile-legends/gift_bg.png": 1070,
	"./mobile-legends/gift_bg_popup_1.png": 1161,
	"./mobile-legends/gift_bg_popup_2.png": 1162,
	"./mobile-legends/payment-award__sku.png": 1163,
	"./mobile-legends/popover-coupon-icon.png": 1028,
	"./mobile-legends/popup-bg-1.png": 1164,
	"./mobile-legends/popup-bg-2.png": 1165,
	"./mobile-legends/popup-bg-invited.png": 1166,
	"./mobile-legends/popup-bg_GT.png": 1167,
	"./mobile-legends/popup-btn-guest.png": 1168,
	"./mobile-legends/popup-btn-owner.png": 1169,
	"./mobile-legends/register-award__sku.png": 1170,
	"./mobile-legends/score-icon.png": 1063,
	"./mobile-legends/sku-icon.png": 1171,
	"./parachute.png": 1071,
	"./pubgm/award-bg.png": 1172,
	"./pubgm/award-icon-1.png": 1173,
	"./pubgm/award__sku.png": 1174,
	"./pubgm/big-sku-icon.png": 1175,
	"./pubgm/button-bg.png": 1176,
	"./pubgm/coupon-icon.png": 1177,
	"./pubgm/coupon-sharee-bg.png": 1178,
	"./pubgm/coupon-sharer-bg.png": 1179,
	"./pubgm/coupon_bg.png": 1180,
	"./pubgm/coupon_bg_popup_1.png": 1181,
	"./pubgm/coupon_bg_popup_2.png": 1182,
	"./pubgm/gift_bg.png": 1183,
	"./pubgm/gift_bg_popup_1.png": 1184,
	"./pubgm/gift_bg_popup_2.png": 1185,
	"./pubgm/login-btn-new.png": 1186,
	"./pubgm/popover-coupon-icon.png": 1005,
	"./pubgm/popup-bg-1.png": 1187,
	"./pubgm/popup-bg-2.png": 1188,
	"./pubgm/popup-bg-bottom.png": 1189,
	"./pubgm/popup-bg-invited.png": 1190,
	"./pubgm/popup-bg_GT.png": 1191,
	"./pubgm/popup-btn-guest.png": 1192,
	"./pubgm/popup-btn-owner.png": 1193,
	"./pubgm/popup-top-icon.png": 1194,
	"./pubgm/pubgm-bg.png": 1195,
	"./pubgm/pubgm-personage.png": 1030,
	"./pubgm/score-icon.png": 1064,
	"./pubgm/sku-icon.png": 1196,
	"./pubgm/small-coupon-icon.png": 1197,
	"./pubgm/small-sku-icon.png": 1198,
	"./pubgm/toplupe-pubgm.png": 1031,
	"./score-bg.png": 1199,
	"./submit-bg.png": 1200,
	"./tip-bg.png": 1201,
	"./user-bg.png": 1061
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1590;